export default __webpack_public_path__ + "static/media/100_45621.521874c3.jpg";